import { Injectable } from '@angular/core';
import { Experiment, ExperimentClient, Variant } from '@amplitude/experiment-js-client';
import { environment } from '@env/environment';

const { AMPLITUDE_EXPERIMENT_KEY } = environment;

@Injectable({
  providedIn: 'root',
})


export class AmplitudeExperimentAction {
  experiment: ExperimentClient;
  private ready?: Promise<void>;

  constructor() {
  }

   /**
   * Get the variant for a given experiment key and validate if it matches 'treatment'.
   * @param key The experiment key to fetch the variant.
   * @returns `true` if the variant key equals 'treatment', otherwise `false`.
   */

   async initializeAmplitudeExperiment(): Promise<void> {
    /* 1. Se já existe uma Promise em andamento ou concluída, reutiliza-a. */
    if (this.ready) {
      return this.ready; // todas as chamadas passam por aqui
    }

    /* 2. Caso o client ainda não exista, cria-o. O mesmo instanceName
          é devolvido nas reinicializações seguintes — é singleton.     */
    this.experiment ??= Experiment.initializeWithAmplitudeAnalytics(AMPLITUDE_EXPERIMENT_KEY, {});

    /* 3. Armazena a Promise e executa start().                         */
    this.ready = (async () => {
      await this.experiment.start();
      await this.experiment.fetch();
      console.log('Amplitude Experiment initialized successfully');
    })().catch(err => {
      // se falhar, limpa `ready` para permitir um retry posterior
      this.ready = undefined;
      throw err;
    });

    return this.ready;
  }

  private getExperimentUser() {
    return this.experiment?.getUser();
  }

  async getVariantByExperimentKey(key: string): Promise<boolean> {
    try {
      await this.initializeAmplitudeExperiment();        // espera a mesma Promise
      const variant: Variant | undefined = this.experiment.variant(key);
      return variant?.key === 'treatment';
    } catch (error) {
      console.error(`Error fetching variant for key ${key}:`, error);
      return false;
    }
  }

  async getFeatureFlagByKey(key: string): Promise<string | undefined> {
    try {
      await this.initializeAmplitudeExperiment();
      return this.experiment?.variant(key)?.value;
    } catch (error) {
      const errorMessage = `Error fetching variant for key ${key}:`
      console.error(errorMessage, error);
      throw new Error(errorMessage);
    }
  }

  async getVariantByKey(key: string): Promise<string> {
    try {
      await this.initializeAmplitudeExperiment();

      const variant = this.experiment.variant(key);
      return variant?.key || 'control';
    } catch (error) {
      const errorMessage = `Error fetching variant for key ${key}:`
      console.error(errorMessage, error);
      throw new Error(errorMessage);
    }
  }

}
